// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4ac2c51c","977":"48858afe"}[chunkId] + ".chunk.js";
};